var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNimbleness(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 6802,
    transform: "translate(-328 -5603)",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -31.5,
    y: -31.5,
    width: 399,
    height: 311,
    rx: 15.5,
    stroke: "#202233",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 16,
    fill: "#FFEDD8"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.4848 42.4018C53.2741 38.0489 50.9564 34.0498 47.3394 31.6786L48.0768 30.5107C52.0802 33.1296 54.6086 37.5534 54.8544 42.3311L53.4848 42.4018Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9998 58.0443C37.6118 58.0443 35.3292 57.4781 33.2222 56.4164L33.8543 55.1777C35.7857 56.1687 37.8225 56.6641 39.9998 56.6641C42.177 56.6641 44.2138 56.1687 46.1452 55.1777L46.7774 56.4164C44.6703 57.5135 42.3877 58.0443 39.9998 58.0443Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5151 42.4018L25.1455 42.3311C25.3913 37.5534 27.9198 33.1296 31.9231 30.5107L32.6606 31.6786C29.0435 34.0498 26.7258 38.0489 26.5151 42.4018Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4064 35.8548C43.3362 35.3947 43.1255 35.0054 42.8094 34.6869C42.4232 34.2976 41.8964 34.0853 41.3696 34.0853H38.6305C38.0686 34.0853 37.577 34.2976 37.1907 34.6869C36.8747 35.0054 36.664 35.3947 36.5937 35.8548L35.2593 35.6425C35.3646 34.8993 35.7158 34.2269 36.2426 33.696C36.8747 33.059 37.7526 32.7051 38.6656 32.7051H41.4048C42.3178 32.7051 43.1606 33.059 43.8278 33.696C44.3546 34.2269 44.6706 34.8993 44.776 35.6425L43.4064 35.8548Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 31.7849C38.3496 31.7849 37.0151 30.4401 37.0151 28.7767C37.0151 27.1134 38.3496 25.7686 40.0001 25.7686C41.6506 25.7686 42.985 27.1134 42.985 28.7767C42.985 30.4401 41.6506 31.7849 40.0001 31.7849ZM40.0001 27.1488C39.1222 27.1488 38.3847 27.892 38.3847 28.7767C38.3847 29.6615 39.1222 30.4047 40.0001 30.4047C40.878 30.4047 41.6155 29.6615 41.6155 28.7767C41.6155 27.892 40.878 27.1488 40.0001 27.1488Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8847 57.3016L47.5503 57.0892C47.6556 56.3461 48.0068 55.6736 48.4985 55.1428C49.1306 54.5058 50.0085 54.1519 50.9215 54.1519H53.6607C54.5737 54.1519 55.4165 54.5058 56.0837 55.1428C56.6105 55.6736 56.9265 56.3461 57.067 57.0892L55.7326 57.3016C55.6623 56.8769 55.4516 56.4522 55.1356 56.1337C54.7493 55.7444 54.2225 55.5321 53.6958 55.5321H50.9566C50.3948 55.5321 49.9031 55.7444 49.5168 56.1337C49.1657 56.4522 48.955 56.8769 48.8847 57.3016Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2911 53.2317C50.6406 53.2317 49.3062 51.8868 49.3062 50.2235C49.3062 48.5602 50.6406 47.2153 52.2911 47.2153C53.9416 47.2153 55.2761 48.5602 55.2761 50.2235C55.2761 51.8868 53.9416 53.2317 52.2911 53.2317ZM52.2911 48.5956C51.4132 48.5956 50.6757 49.3387 50.6757 50.2235C50.6757 51.1083 51.4132 51.8514 52.2911 51.8514C53.169 51.8514 53.9065 51.1083 53.9065 50.2235C53.9065 49.3387 53.169 48.5956 52.2911 48.5956Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1154 57.3016C31.0452 56.8415 30.8345 56.4522 30.5184 56.1337C30.1321 55.7444 29.6054 55.5321 29.0786 55.5321H26.3395C25.7776 55.5321 25.286 55.7444 24.8997 56.1337C24.5836 56.4522 24.3729 56.8415 24.3027 57.3016L22.9683 57.0892C23.0736 56.3461 23.4248 55.6736 23.9515 55.1428C24.5836 54.5058 25.4616 54.1519 26.3746 54.1519H29.1137C30.0268 54.1519 30.8696 54.5058 31.5368 55.1428C32.0636 55.6736 32.3796 56.3461 32.5201 57.0892L31.1154 57.3016Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7091 53.2317C26.0586 53.2317 24.7241 51.8868 24.7241 50.2235C24.7241 48.5602 26.0586 47.2153 27.7091 47.2153C29.3596 47.2153 30.694 48.5602 30.694 50.2235C30.694 51.8868 29.3596 53.2317 27.7091 53.2317ZM27.7091 48.5956C26.8311 48.5956 26.0937 49.3387 26.0937 50.2235C26.0937 51.1083 26.8311 51.8514 27.7091 51.8514C28.587 51.8514 29.3245 51.1083 29.3245 50.2235C29.3245 49.3387 28.6221 48.5956 27.7091 48.5956Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7021 38.8276H39.3325V43.0745H40.7021V38.8276Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6669 42.4953L36.0176 44.6191L36.7025 45.8144L40.3519 43.6906L39.6669 42.4953Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3318 42.4869L39.647 43.6821L43.2963 45.8055L43.9811 44.6103L40.3318 42.4869Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 37.5889C35.189 37.5889 31.291 33.6252 31.291 28.7768C31.291 23.9283 35.189 20 40 20C44.8111 20 48.7091 23.9283 48.7091 28.7768C48.7091 33.6252 44.8111 37.5889 40 37.5889ZM40 21.3802C35.9616 21.3802 32.6606 24.7069 32.6606 28.7768C32.6606 32.8466 35.9616 36.1733 40 36.1733C44.0385 36.1733 47.3395 32.8466 47.3395 28.7768C47.3395 24.7069 44.0736 21.3802 40 21.3802Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2911 58.9998C47.48 58.9998 43.582 55.0715 43.582 50.2231C43.582 45.3746 47.48 41.4463 52.2911 41.4463C57.1021 41.4463 61.0001 45.3746 61.0001 50.2231C61.0001 55.0715 57.1021 58.9998 52.2911 58.9998ZM52.2911 42.8265C48.2526 42.8265 44.9516 46.1532 44.9516 50.2231C44.9516 54.2929 48.2526 57.6196 52.2911 57.6196C56.3295 57.6196 59.6305 54.2929 59.6305 50.2231C59.6305 46.1532 56.3295 42.8265 52.2911 42.8265Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.709 58.9998C22.898 58.9998 19 55.0715 19 50.2231C19 45.3746 22.898 41.4463 27.709 41.4463C32.5201 41.4463 36.4181 45.3746 36.4181 50.2231C36.4532 55.0715 32.5201 58.9998 27.709 58.9998ZM27.709 42.8265C23.6706 42.8265 20.3696 46.1532 20.3696 50.2231C20.3696 54.2929 23.6706 57.6196 27.709 57.6196C31.7475 57.6196 35.0485 54.2929 35.0485 50.2231C35.0836 46.1532 31.7826 42.8265 27.709 42.8265Z",
    fill: "#FD7E3B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 6802,
    fill: "white",
    transform: "translate(-328 -5603)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 39,
    fill: "white",
    transform: "translate(19 20)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNimbleness);
export default __webpack_public_path__ + "static/media/nimbleness.e14d607b3e71644dd055f93a029432b0.svg";
export { ForwardRef as ReactComponent };